module.exports = __webpack_public_path__ + "img/tips-gear-packing.c1c4130e.svg";